// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3OksV","footer":"ChangeClinic_footer__3E9fe"};